import React, { useContext } from 'react';
import { ConfigContext } from "../../App";
import PNSHeader from '../pnsheader/pnsheader';
import parse from 'html-react-parser';
import OMEGA from '../../omega';
import { OMEGA_ENV } from '../../constants';
import './teams.scss';

export default function TeamsError() {
    const locales = useContext(ConfigContext).appConfig.languageData;
    
    OMEGA.init().updateAndTrack('page', {
        hierarchy: "home:teams:failed",
        name: "Teams Subscription - Failed",
        url: encodeURIComponent(window.location.href),
        type: "teams",
        env: OMEGA_ENV
    });

    return (
        <div className="teams-error-container">
            <PNSHeader noText="true" manageSubscription="true" />
            <div className="status-teams-error">
                <p className="error-head">{locales.teams_setup_error_title}</p>
                <div className="error-image"></div>
                <p className="error-description">
                    {parse(locales.teams_error_message_description_line1)}
                    <br />
                    {parse(locales.teams_error_message_description_line2)}
                    <br />
                    {parse(locales.teams_error_message_description_line3)}
                    <br />
                    {parse(locales.teams_error_message_description_line4)}
                </p>
            </div>
        </div>
    );
} 